import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { RadioGroupFormControl } from './radio-group-form-control';

@Component({
    selector: 'app-radio-group-form-control',
    templateUrl: './radio-group-form-control.component.html',
})
export class RadioGroupFormControlComponent extends AbstractFormControlComponent<RadioGroupFormControl> {
    @Output() onChange: EventEmitter<boolean> = new EventEmitter();
    @Input() parentForm: FormGroup;
    @Input() title: string;
    @Input() controlName: string;
    @Input() inline: boolean;

    change(): void {
        this.onChange.emit(this.control.value);
    }

    public get collection(): any[] {
        return this.control.collection || [];
    }

    public get keyPropertyName(): string {
        return this.control.keyPropertyName || 'name';
    }

    public get valuePropertyName(): string {
        return this.control.valuePropertyName || 'name';
    }

    public get isInline(): boolean {
        return this.inline || false;
    }
}
